import { defineMessages } from 'react-intl'

const scope = `procurify.core.components.SecondaryCategorySelect`

export default defineMessages({
  placeholderText: {
    id: `${scope}.placeholderText`,
    defaultMessage: 'Select a {singularSecondaryOrgCategoryLabel}',
  },
})
